import wrapperHOC from "@Utils/wrapperHOC";

const RatingStarFilled = ({ size = 32 }) => (
  <svg
    width={size}
    height={size - 2}
    viewBox="0 0 32 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.7061 1.05469C17.3932 0.410156 16.7321 0 16.0061 0C15.28 0 14.6248 0.410156 14.3061 1.05469L10.5106 8.80664L2.03418 10.0488C1.32585 10.1543 0.735569 10.6465 0.517166 11.3203C0.298764 11.9941 0.475847 12.7383 0.983486 13.2363L7.13418 19.2773L5.6821 27.8145C5.56404 28.5176 5.85918 29.2324 6.44355 29.6484C7.02793 30.0645 7.80119 30.1172 8.43869 29.7832L16.012 25.7695L23.5852 29.7832C24.2227 30.1172 24.996 30.0703 25.5804 29.6484C26.1647 29.2266 26.4599 28.5176 26.3418 27.8145L24.8838 19.2773L31.0345 13.2363C31.5422 12.7383 31.7252 11.9941 31.5008 11.3203C31.2765 10.6465 30.6922 10.1543 29.9838 10.0488L21.5015 8.80664L17.7061 1.05469Z"
      fill="#0E9F6E"
      style={{ fill: "#0E9F6E", fillOpacity: 1 }}
    />
  </svg>
);

export default wrapperHOC(RatingStarFilled, {
  componentName: "RatingStarFilled-icons",
  showForChina: true,
});
